export default __webpack_public_path__ + "static/nich-89b137f43442f3f1cc4be8de98996eb6.jpg";